export default class Config {
    static siteUrl = "https://www.owwco.com/OrderForms.UI/";
    static baseApiUrl = "https://api.owwco.com/OrderForms.API/";
    static baseSecurityUrl = "https://api.owwco.com/Security.API/";
    static gatewayAccountUrl = "https://api.owwco.com/Gateway.UI/Account/"
}